import { Provider } from '@angular/core';
import { MANAGE_INFO_CLIENT_REPOSITORY } from './application/manage-info-client.tokens';
import { HttpManageInfoClientRepository } from './infrastructure/http/http-manage-info-client.repository';
import { GetConstitutionDetailUseCase } from './application/get-constitution-detail.usecase';
import { UpdateConstitutionFieldUseCase } from './application/update-constitution-field.usecase';
import { UpdateConstitutionPartnerFieldsUseCase } from './application/update-constitution-partner-fields.usecase';
import { UpdateBusinessNameReservationUseCase } from './application/update-business-name-reservation.usecase';
import { GenerateAutomatedMinuteUseCase } from './application/generate-automated-minute.usecase';
import { GetKushkiPaymentsUseCase } from './application/get-kushki-payments.usecase';
import { GetCapitalRangeCatalogUseCase } from './application/get-capital-range-catalog.usecase';
import { GetPartnersCatalogUseCase } from './application/get-partners-catalog.usecase';

export const MANAGE_INFO_CLIENT_PROVIDERS: Provider[] = [
  { provide: MANAGE_INFO_CLIENT_REPOSITORY, useClass: HttpManageInfoClientRepository },
  GetConstitutionDetailUseCase,
  UpdateConstitutionFieldUseCase,
  UpdateConstitutionPartnerFieldsUseCase,
  UpdateBusinessNameReservationUseCase,
  GenerateAutomatedMinuteUseCase,
  GetKushkiPaymentsUseCase,
  GetCapitalRangeCatalogUseCase,
  GetPartnersCatalogUseCase,
];
